module.exports = __webpack_public_path__ + "media/CuteAdventure.5d8141a8.mp3";